import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/Time/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Time',
  field: 'Measurement',
  weeks: [10, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Time/1BeforeAndAfter" */ './1BeforeAndAfter')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Time/2DaysOfTheWeek" */ './2DaysOfTheWeek')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year1/Summer/Time/3MonthsOfTheYear" */ './3MonthsOfTheYear')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Time/4HoursMinutesAndSeconds" */ './4HoursMinutesAndSeconds'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Time/5TellTheTimeToTheHour" */ './5TellTheTimeToTheHour'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/Time/6TellTheTimeToTheHalfHour" */ './6TellTheTimeToTheHalfHour'
        )
    })
  ]
});
export default Block;
